/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /vise/packages/app-share/src/services/fetch-collection-feeds/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { formatFeed, formatCollectionInfo } from '@/utils/formatter';
import { H5_CALL_PATH } from '@/constants/url';
import { ModelCollectionInfo, ModelMetaFeed } from '@/types/model';
import { FetchCollectionFeedsReq, FetchCollectionFeedsRsp } from '@/types/services/fetch-collection-feeds';

type FetchResult = {
  collection: null | ModelCollectionInfo,
  feedList: ModelMetaFeed[],
};

/**
 *
 * 获取合集的feed流
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export default async function fetchCollectionFeeds(params: FetchCollectionFeedsReq): Promise<FetchResult> {
  const fetchConfig: AjaxConfig = {
    url: `${H5_CALL_PATH}/weishi/WSGetCollectionFeedList`,
    withCredentials: true,
    method: 'GET',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    params: {
      feedId: params.feedId,
      cid: params.collectionId,
      sceneId: 6,
    },
  };
  let collection = null;
  let feedList: ModelMetaFeed[] = [];
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return { collection, feedList };
  try {
    const { request } = wslAjax;
    const res = await request<FetchCollectionFeedsRsp>(fetchConfig);
    feedList = (res?.data?.feedList || []).map((item, index) => formatFeed(item.feed, index));
    collection = formatCollectionInfo(res?.data?.collection);
  } catch (err) {
    console.error('接口fetchCollectionFeeds出现了一些问题');
  }
  return { collection, feedList };
}
